import {Base} from "@/api/Base"

export class UploadRecordAdd extends Base {
    path = "uploadRecord/add"
}